export default __webpack_public_path__ + "static/museo-sans-regular-d3324ccba7fafc09d3b01ec12f3edf97.ttf";